import { MijnRoute } from '../../mijn-navigatie.model';

export const BALANCE_CHART: MijnRoute = {
    path: 'saldografiek',
    navigationEvent: 'toBalanceChart',
    regex: /^\/saldografiek$/,
    webcomponent: 'mijn-saldo-grafiek-webcomponent'
};
